"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Waiver = void 0;
const mobx_1 = require("mobx");
const print_util_1 = require("../../print-util");
/**
 * Page 5
 * - Patient waiver
 */
class Waiver extends print_util_1.PrintUtil {
    constructor(printMeta, lastPage) {
        super();
        this.printMeta = printMeta;
        this.lastPage = lastPage;
        this.make = () => {
            var _a, _b;
            const { claim, barcode, patientSignature, historic } = this.printMeta;
            const currentClaim = mobx_1.toJS(claim);
            const order = currentClaim.order;
            const patient = (_a = historic === null || historic === void 0 ? void 0 : historic.patientData) !== null && _a !== void 0 ? _a : order.patient;
            const site = (_b = historic === null || historic === void 0 ? void 0 : historic.siteData) !== null && _b !== void 0 ? _b : order.site;
            const patientGender = patient.gender === "1" ? "Male" : "Female";
            const pageBreak = this.lastPage ? "" : "after";
            return [
                {
                    margin: [0, 0, 0, 20],
                    layout: "noBorders",
                    table: {
                        widths: [120, 120],
                        headerRows: 1,
                        body: [
                            [
                                {
                                    stack: [
                                        `${patient.lastName || ""} ${patient.firstName || ""}`,
                                        `${patient.address || ""}, ${patient.city ||
                                            ""} ${patient.state || ""} ${patient.zip || ""}`,
                                        `DOB: ${patient.birthDate || ""}`,
                                        `Gender: ${patientGender || ""}`
                                    ],
                                    fontSize: 8
                                },
                                { image: barcode, width: 75 }
                            ]
                        ]
                    }
                },
                {
                    text: "Patient Medication Waiver",
                    fontSize: 16,
                    alignment: "center"
                },
                {
                    style: "tableText",
                    stack: [
                        "In keeping with our mission to deliver quality, convenient, patient-centered care, " +
                            `${site.name ||
                                ""} offers its patients in-office dispensing of select ` +
                            "medications. Doing so will better ensure you receive your medication as quickly and " +
                            "cost-effectively as possible so treatment can start right away.",
                        {
                            text: "If you decide to fill your prescription at another pharmacy, your decision will in " +
                                "no way affect the medical care you receive from our health care professionals.",
                            margin: [0, 10, 0, 10]
                        },
                        {
                            text: "I hereby acknowledge reading and understanding the above information provided for the " +
                                "in-office dispensing program and have been given to opportunity to ask questions and wish " +
                                `to obtain my prescription from ${site.name || ""}.`,
                            bold: true,
                            margin: [0, 0, 0, 50]
                        }
                    ]
                },
                {
                    image: patientSignature,
                    width: 100,
                    relativePosition: { x: 75, y: 5 }
                },
                {
                    style: "prescriberAgent",
                    text: `Patient Signature:                                                        , Date: ${this.orderCreateDate(order.createDate)} `,
                    alignment: "left",
                    relativePosition: { x: 0, y: 15 },
                    pageBreak
                }
            ];
        };
    }
}
exports.Waiver = Waiver;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/labels/print-labels/print-manager/sheets/waiver/waiver.ts
// module id = 2747
// module chunks = 0 1